import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { compose } from '@beef/utils';
import { withReduxStore } from '@beef/redux';
import { Modal, Text } from '@carnica/ui-kit';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import { useDispatch } from 'react-redux';
import { setFooterTheme } from "./store/slices/layout";
import { selectFooterLayout } from "./store/slices/layout/selector";
import { AppBlock, FooterLayout, FooterLayoutColumn, LinksBlock, SubscriptionForm } from "./components";
import styles from "./styles.pcss";
import { Metric, withMetricContainer } from "./metric";
import { initializeStore, useAppSelector } from "./store";
var cx = classNames.bind(styles);
var _Footer = function _Footer(_ref) {
  var modal = _ref.modal,
    theme = _ref.theme;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var footerTheme = useAppSelector(selectFooterLayout);
  var dispatch = useDispatch();
  var openModal = useCallback(function (e) {
    e.preventDefault();
    setIsOpen(true);
  }, []);
  var handleChangeTheme = useCallback(function (event) {
    dispatch(setFooterTheme(event.detail));
  }, []);
  useEffect(function () {
    if (theme) dispatch(setFooterTheme(theme));
    window.addEventListener('footerthemechange', handleChangeTheme);
    return function () {
      window.removeEventListener('footerthemechange', handleChangeTheme);
    };
  }, []);
  return /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    events: {
      footerMetric: ['onViewFooter']
    },
    mode: "viewport",
    once: true,
    "data-t-id": "Footers-Footer"
  }, /*#__PURE__*/React.createElement("footer", {
    className: cx('footer', cnComponentsTheme('light'), "footer-theme__".concat(footerTheme)),
    "data-t-id": "Footers-Footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('footer-container')
  }, /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    },
    portalClassName: cx('modal-portal')
  }, /*#__PURE__*/React.createElement(Text, {
    className: cx('modal-content'),
    tagName: "div",
    variant: "body-medium",
    "data-t-id": "Footers-Footer"
  }, modal.content)), /*#__PURE__*/React.createElement(FooterLayout, null, /*#__PURE__*/React.createElement(FooterLayoutColumn, {
    className: cx('footer__bordered'),
    "data-t-id": "Footers-Footer"
  }, /*#__PURE__*/React.createElement(SubscriptionForm, {
    onClick: openModal,
    "data-t-id": "Footers-Footer"
  }), /*#__PURE__*/React.createElement(AppBlock, null)), /*#__PURE__*/React.createElement(LinksBlock, null)))));
};
export var Footer = compose(withReduxStore(initializeStore, {
  mapPropsToState: function mapPropsToState(_ref2) {
    var data = _ref2.data;
    return {
      data: data
    };
  },
  passThroughProps: function passThroughProps(_ref3) {
    var data = _ref3.data;
    return {
      modal: data.modal,
      theme: data.theme
    };
  }
}), withMetricContainer)(_Footer);